import { useTranslation } from "react-i18next";
import { LifestyleUseCasesData } from "./types";

export const useSmartBandLifestyleData = (): LifestyleUseCasesData => {
    const { t } = useTranslation("bandLifestyle");

    return {
        categories: [
            { id: "training", name: t("categories.training") },
            { id: "recovery", name: t("categories.recovery") },
            { id: "lifestyle", name: t("categories.lifestyle") },
        ],

        useCases: [
            // صبح (Morning)
            {
                image: "/media/landing/LifestyleUseCases/band/1.webp",
                title: t("useCases.0.title"),
                description: t("useCases.0.description"),
                time: t("useCases.0.time"),
                category: "lifestyle",
                color: "from-sky-400 to-cyan-500",
                main: false,
                tags: t("useCases.0.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/2.webp",
                title: t("useCases.1.title"),
                description: t("useCases.1.description"),
                time: t("useCases.1.time"),
                category: "recovery",
                color: "from-sky-400 to-cyan-500",
                main: false,
                tags: t("useCases.1.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/3.webp",
                title: t("useCases.2.title"),
                description: t("useCases.2.description"),
                time: t("useCases.2.time"),
                category: "training",
                color: "from-sky-400 to-cyan-500",
                main: false,
                tags: t("useCases.2.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/4.webp",
                title: t("useCases.3.title"),
                description: t("useCases.3.description"),
                time: t("useCases.3.time"),
                category: "training",
                color: "from-sky-400 to-cyan-500",
                main: true,
                tags: t("useCases.3.tags", { returnObjects: true }) as string[],
            },

            // ظهر (Noon)
            {
                image: "/media/landing/LifestyleUseCases/band/5.webp",
                title: t("useCases.4.title"),
                description: t("useCases.4.description"),
                time: t("useCases.4.time"),
                category: "lifestyle",
                color: "from-amber-400 to-orange-500",
                main: false,
                tags: t("useCases.4.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/6.webp",
                title: t("useCases.5.title"),
                description: t("useCases.5.description"),
                time: t("useCases.5.time"),
                category: "recovery",
                color: "from-amber-400 to-orange-500",
                main: false,
                tags: t("useCases.5.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/7.webp",
                title: t("useCases.6.title"),
                description: t("useCases.6.description"),
                time: t("useCases.6.time"),
                category: "training",
                color: "from-amber-400 to-orange-500",
                main: false,
                tags: t("useCases.6.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/8.webp",
                title: t("useCases.7.title"),
                description: t("useCases.7.description"),
                time: t("useCases.7.time"),
                category: "training",
                color: "from-amber-400 to-orange-500",
                main: true,
                tags: t("useCases.7.tags", { returnObjects: true }) as string[],
            },

            // عصر (Afternoon)
            {
                image: "/media/landing/LifestyleUseCases/band/9.webp",
                title: t("useCases.8.title"),
                description: t("useCases.8.description"),
                time: t("useCases.8.time"),
                category: "training",
                color: "from-indigo-500 to-violet-600",
                main: true,
                tags: t("useCases.8.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/10.webp",
                title: t("useCases.9.title"),
                description: t("useCases.9.description"),
                time: t("useCases.9.time"),
                category: "training",
                color: "from-indigo-500 to-violet-600",
                main: true,
                tags: t("useCases.9.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/11.webp",
                title: t("useCases.10.title"),
                description: t("useCases.10.description"),
                time: t("useCases.10.time"),
                category: "recovery",
                color: "from-indigo-500 to-violet-600",
                main: true,
                tags: t("useCases.10.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/12.webp",
                title: t("useCases.11.title"),
                description: t("useCases.11.description"),
                time: t("useCases.11.time"),
                category: "lifestyle",
                color: "from-indigo-500 to-violet-600",
                main: false,
                tags: t("useCases.11.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/13.webp",
                title: t("useCases.12.title"),
                description: t("useCases.12.description"),
                time: t("useCases.12.time"),
                category: "recovery",
                color: "from-indigo-500 to-violet-600",
                main: false,
                tags: t("useCases.12.tags", { returnObjects: true }) as string[],
            },

            // شب (Night)
            {
                image: "/media/landing/LifestyleUseCases/band/14.webp",
                title: t("useCases.13.title"),
                description: t("useCases.13.description"),
                time: t("useCases.13.time"),
                category: "lifestyle",
                color: "from-slate-800 to-gray-900",
                main: false,
                tags: t("useCases.13.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/16.webp",
                title: t("useCases.14.title"),
                description: t("useCases.14.description"),
                time: t("useCases.14.time"),
                category: "recovery",
                color: "from-slate-800 to-gray-900",
                main: true,
                tags: t("useCases.14.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/16.webp",
                title: t("useCases.15.title"),
                description: t("useCases.15.description"),
                time: t("useCases.15.time"),
                category: "recovery",
                color: "from-slate-800 to-gray-900",
                main: false,
                tags: t("useCases.15.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/17.webp",
                title: t("useCases.16.title"),
                description: t("useCases.16.description"),
                time: t("useCases.16.time"),
                category: "training",
                color: "from-slate-800 to-gray-900",
                main: false,
                tags: t("useCases.16.tags", { returnObjects: true }) as string[],
            },

            // تمام روز (All Day)
            {
                image: "/media/landing/LifestyleUseCases/band/18.webp",
                title: t("useCases.17.title"),
                description: t("useCases.17.description"),
                time: t("useCases.17.time"),
                category: "recovery",
                color: "from-green-500 to-lime-600",
                main: true,
                tags: t("useCases.17.tags", { returnObjects: true }) as string[],
            },
            {
                image: "/media/landing/LifestyleUseCases/band/18.webp",
                title: t("useCases.18.title"),
                description: t("useCases.18.description"),
                time: t("useCases.18.time"),
                category: "lifestyle",
                color: "from-fuchsia-500 to-pink-600",
                main: true,
                tags: t("useCases.18.tags", { returnObjects: true }) as string[],
            },
        ],
    };
};
